import { observable, action } from 'mobx'
import { isEmpty } from 'lodash'
import { Request2 } from 'src/common/Request2'
import api from 'src/common/api'
import { responseDefault } from './store.constants'

export class ApiKeyStore {
   @observable listApiKey: any = { ...responseDefault }

   // Key vua tao — server chi tra plaintext dung 1 lan nen phai giu tam o day
   @observable createdKey: string = ''

   @action
   async getApiKeys(params: any = {}) {
      const result = await Request2.getWithToken(api.apiKey.getList, params)
      if (!isEmpty(result)) {
         this.listApiKey = result
      } else {
         this.listApiKey = { ...responseDefault }
      }
      return result
   }

   /**
    * Tao key moi. Tra ve plaintext key (chi hien thi duoc dung lan nay).
    */
   @action
   async createApiKey(accountId: number, name: string = '', expiresAt: string | null = null) {
      const body: any = { accountId }
      if (name) body.name = name
      if (expiresAt) body.expiresAt = expiresAt

      const result = await Request2.postWithToken(body, api.apiKey.create)
      const apiKey = result?.data?.apiKey || ''
      if (apiKey) {
         this.createdKey = apiKey
      }
      return apiKey
   }

   @action
   async revokeApiKey(id: number) {
      const result = await Request2.postWithToken({}, `${api.apiKey.revoke}/${id}/revoke`)
      return result?.code === 200 || result?.code === '200'
   }

   @action
   async deleteApiKey(id: number) {
      const result = await Request2.deleteWithToken({}, `${api.apiKey.delete}/${id}`)
      return !!result
   }

   @action
   clearCreatedKey() {
      this.createdKey = ''
   }
}
